import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const DropZoneContainer = styled.div<{ active: boolean }>`
  width: 300px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokens.radius.control};
  background-color: ${(props) => (props.active ? tokens.accent.soft : tokens.surface.inset)};
  transition: 0.2s ease-out;
  cursor: pointer;
  border: 2px dashed ${(props) => (props.active ? tokens.accent.base : tokens.border.strong)};

  &:hover {
    background-color: ${tokens.surface.raised};
  }

  input {
    opacity: 0;
  }
`
